import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/sagas/utilization";
import Heatmap from "../../../../components/heatMap/heatMap";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { GroupByTimeOfDayChart } from "./groupByTimeOfDayChart";
import { GroupByFilter } from "./groupByFilter";

const getMockChart = () => {
  return [
    {
      name: "",
      data: Array.from({ length: 7 }, () => ({
        x: "с 0",
        y: 0,
        toolTipData: "--",
        modalData: { showWithoutModalWindow: true },
        displayValue: "--",
        valueSymbol: ""
      }))
    }
  ];
};

function reOrderDays(series) {
  const clonedSeries = series.slice(0);

  return clonedSeries.map((item) => {
    // move sunday to the last element of the array to match the column order
    if (item.data[0].toolTipData.includes("Sunday")) {
      item.data.push(item.data.shift());
    }

    return item;
  });
}

export const HeatmapChart = ({ groupByTimeOfDaySeries, categories }) => {
  const dispatch = useDispatch();

  let isUserQa = useSelector((state) => state.utilization.currentUser.qa);
  let tableDataLoading = useSelector((state) => state.utilization.tableDataLoading);

  let series = useSelector((state) => state.utilization.series);
  let modalTableData = useSelector((state) => state.utilization.modalTableData);

  let groupByWeekDay = useSelector((state) => state.utilization.groupByWeekDay);
  let groupByTimeOfDay = useSelector((state) => state.utilization.groupByTimeOfDay);

  let averageTooltip = useSelector((state) => state.utilization.averageTooltip);
  let showAverages = useSelector((state) => state.utilization.showAverages);

  let selectedCategory = useSelector((state) => state.utilization.selectedCategoryFilters.name);
  let showUtilizationPrevPeriod = useSelector(
    (state) => state.utilization.showUtilizationPrevPeriod
  );

  const mockChart = getMockChart();

  const seriesProps =
    groupByTimeOfDaySeries !== undefined
      ? groupByTimeOfDaySeries
      : showAverages && !series.length
      ? mockChart
      : reOrderDays(series);

  return (
    <>
      <Heatmap
        categories={categories}
        heatMapRadius={15}
        stroke={0.5}
        groupByWeekDay={groupByWeekDay}
        series={seriesProps}
        tableDataLoading={tableDataLoading}
        modalTableData={{
          nestedRows: true,
          ...modalTableData
        }}
        groupByTimeOfDay={groupByTimeOfDay}
        displayAsBubbles={false}
        filledBubbles
        isUserQa={isUserQa}
        modalProps={{
          selectedCategory: selectedCategory,
          progressInPercent: true,
          showAverageRevenue: true,
          showTotalClasses: true,
          showNumberOfClients: true,
          showPrevPeriod: showUtilizationPrevPeriod,
          mainMetricTitle: "Utilization",
          detailsTitle: "Class Details",
          averageTooltip: averageTooltip,
          tableHeight: showUtilizationPrevPeriod ? 300 : 320
        }}
        handleDataClick={(tableDataUid) => {
          dispatch(actionCreators.getTableData({ tableDataUid }));
        }}
        showAddons={!groupByTimeOfDay ? { exportXlsx: true, exportPng: true } : {}}
      />
    </>
  );
};

export const UtilizationHeatmap = () => {
  const groupByTimeOfDay = useSelector((state) => state.utilization.groupByTimeOfDay);
  const currentSelectedCategory = useSelector((state) => state.utilization.currentSelectedCategory);
  const updatesLoading = useSelector((state) => state.utilization.updatesLoading);

  return (
    <div style={{ paddingTop: "50px" }}>
      <div className="heatmap-heading">
        <h2>{currentSelectedCategory} Heatmap</h2>
        <div className="group-by-filter">
          <GroupByFilter />
        </div>
      </div>
      {updatesLoading ? (
        <LoadingAnimation />
      ) : groupByTimeOfDay ? (
        <GroupByTimeOfDayChart />
      ) : (
        <HeatmapChart />
      )}
    </div>
  );
};
